import { render, staticRenderFns } from "./checkboxItemStyle.vue?vue&type=template&id=0cd7dae6&scoped=true"
import script from "./checkboxItemStyle.vue?vue&type=script&lang=js"
export * from "./checkboxItemStyle.vue?vue&type=script&lang=js"
import style0 from "./checkboxItemStyle.vue?vue&type=style&index=0&id=0cd7dae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd7dae6",
  null
  
)

export default component.exports